/**
* Hreflang helpers for the /lgz/* cluster. Thai canonical is x-default;
* 6 locale mirrors advertised so Google consolidates ranking signals.
*/
const BASE = "https://thainotarylaw.com";
const LOCALES = ["en", "zh", "ja", "ko", "vi", "id"] as const;

export const LGZ_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: `${BASE}/lgz` },
  ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}/lgz` })),
  { rel: "alternate", hrefLang: "x-default", href: `${BASE}/lgz` },
];

export function lgzServiceHreflangLinks(slug: string) {
  const svc = `/lgz/services/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${svc}` },
    ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}${svc}` })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${svc}` },
  ];
}

export function lgzCountryHreflangLinks(slug: string) {
  const p = `/lgz/country/${slug}`;
  return [
    { rel: "alternate", hrefLang: "th", href: `${BASE}${p}` },
    ...LOCALES.map((l) => ({ rel: "alternate" as const, hrefLang: l, href: `${BASE}/${l}${p}` })),
    { rel: "alternate", hrefLang: "x-default", href: `${BASE}${p}` },
  ];
}
